import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "batch-item-container" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick", "disabled"]
const _hoisted_5 = { class: "batch-item" }
const _hoisted_6 = { class: "left-controls" }
const _hoisted_7 = ["data-bs-target"]
const _hoisted_8 = ["checked", "disabled"]
const _hoisted_9 = { class: "tags-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_burst_item = _resolveComponent("burst-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "collapse",
      id: `collapse-${_ctx.batch.BatchID}`
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedBursts, (burst) => {
        return (_openBlock(), _createBlock(_component_burst_item, {
          key: burst,
          burst: burst,
          toggleBurst: _ctx.toggle_burst
        }, {
          buttons: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-success btn-sm",
              title: "Plot graph",
              onClick: () => _ctx.plotGraph(burst)
            }, [
              _createVNode(_component_vue_feather, {
                type: "bar-chart",
                size: "16px"
              })
            ], 8, _hoisted_3),
            _createElementVNode("button", {
              class: "btn btn-warning btn-sm",
              title: "Download CSV",
              onClick: () => _ctx.downloadBurst(burst),
              disabled: _ctx.burstDownloading !== null
            }, [
              _withDirectives(_createVNode(_component_loading_spinner, { size: "16px" }, null, 512), [
                [_vShow, _ctx.burstDownloading === burst.BurstID]
              ]),
              _withDirectives(_createVNode(_component_vue_feather, {
                type: "download",
                size: "16px"
              }, null, 512), [
                [_vShow, _ctx.burstDownloading !== burst.BurstID]
              ])
            ], 8, _hoisted_4)
          ]),
          _: 2
        }, 1032, ["burst", "toggleBurst"]))
      }), 128))
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-success collapse-button collapsed",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": `#collapse-${_ctx.batch.BatchID}`
        }, [
          _createVNode(_component_vue_feather, {
            type: "chevron-right",
            size: "12"
          })
        ], 8, _hoisted_7),
        _createElementVNode("input", {
          type: "checkbox",
          onChange: _cache[0] || (_cache[0] = () => _ctx.toggleBatch(_ctx.batch)),
          checked: _ctx.batchSelected(_ctx.batch),
          disabled: _ctx.maxBurstsSelected() && !_ctx.batchSelected(_ctx.batch)
        }, null, 40, _hoisted_8),
        _createElementVNode("div", null, "Batch " + _toDisplayString(_ctx.batch.BatchID) + ": " + _toDisplayString(_ctx.batch.BatchName), 1)
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.formatTime(_ctx.batch.StartTime)), 1),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topBatchTags, (tag) => {
          return (_openBlock(), _createElementBlock("div", { key: tag }, _toDisplayString(tag), 1))
        }), 128))
      ])
    ])
  ]))
}